import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmationActionComponent } from 'app/components/ui/dialogs/confirmation-action/confirmation-action.component';
import { ConfirmationActionTypes } from 'app/components/ui/dialogs/confirmation-action/confirmation-action.types';
import { generalConsts } from 'app/services/consts/general.consts';

@Component({
    selector: 'change-email-modal',
    templateUrl: './change-email-modal.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule
    ]
})
export class ChangeEmailModalComponent implements OnInit {
    changeEmailForm: FormGroup;
    loading: boolean = false;

    confirmationChangeEmailDataObject: ConfirmationActionTypes = {
        title: generalConsts.modules.user.account.dialogs.confirmationChangeEmailDataObject.title,
        type: generalConsts.application.dialogs.type.confirmation,
        closeable: true,
        yesButton: { use: true },
        noButton: { use: true },
        cancelButton: { use: false },
        message: generalConsts.modules.user.account.dialogs.confirmationChangeEmailDataObject.message,
    };

    constructor(
        public dialogRef: MatDialogRef<ChangeEmailModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private _matDialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.changeEmailForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            confirmEmail: ['', Validators.required]
        }, {
            validators: this.emailMatchValidator
        });
    }

    emailMatchValidator(group: FormGroup): { [key: string]: boolean } | null {
        const email = group.get('email')?.value;
        const confirmEmail = group.get('confirmEmail')?.value;
        return email === confirmEmail ? null : { emailMismatch: true };
    }

    saveEmail(): void {
        if (this.changeEmailForm.invalid) {
            return;
        }

        // Abre o dialog de confirmação
        const confirmationDialogRef = this._matDialog.open(ConfirmationActionComponent, {
            autoFocus: false,
            data: {
                data: this.confirmationChangeEmailDataObject,
            },
            disableClose: true,
            width: '95%',
            maxWidth: '500px',
        });

        confirmationDialogRef.afterClosed().subscribe(result => {
            if (result && result.action === generalConsts.modules.user.account.dialogs.actions.yes) {
                this.processEmailChange();
            }
        });
    }

    processEmailChange(): void {
        this.loading = true;

        // Simula uma requisição (implementar a lógica real depois)
        setTimeout(() => {
            this.loading = false;
            this.dialogRef.close({ action: 'saved' });
        }, 1500);
    }

    closeModal(): void {
        this.dialogRef.close();
    }
}
